import { userPreferencesApiConnector } from 'apiConnector/userPreferences/userPreferences';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import { getUserPreferencesCurrency } from 'state/selectors';
import type { EpicWithThunk } from 'state/state.common';
import {
  userPreferencesAvailableCurrenciesReceived,
  userPreferencesDefaultFieldValuesChanged,
} from 'state/userPreferences/userPreferences.action';

export interface FetchUserPreferencesAvailableCurrenciesApi {
  fetchAvailableCurrencies(productSubtype: string): Observable<ReadonlyArray<string | null>>;
}

export function updateUserPreferencesAvailableCurrenciesEpic(): EpicWithThunk {
  return (action$, state$, { selectors: { getUserPreferencesProductSubtype }, httpClient }) =>
    action$.pipe(
      ofType('USER_PREFERENCES_DEFAULT_FIELD_VALUES_CHANGED'),
      filter(x => x.key === 'productSubtype' || x.key === 'productType'),
      withLatestFrom(state$),
      mergeMap(([_, state]) => {
        const productSubtype = getUserPreferencesProductSubtype(state)!;
        const currency = getUserPreferencesCurrency(state) ?? null;
        return userPreferencesApiConnector(httpClient)
          .fetchAvailableCurrencies(productSubtype)
          .pipe(
            mergeMap(currencies => {
              if (!currencies.includes(currency)) {
                return of(
                  userPreferencesAvailableCurrenciesReceived(currencies),
                  userPreferencesDefaultFieldValuesChanged('currency', undefined),
                );
              }
              return of(userPreferencesAvailableCurrenciesReceived(currencies));
            }),
            catchError(() => {
              return EMPTY;
            }),
          );
      }),
    );
}
